import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  table: {
    title: null,
    headers: [
      { text: 'Brand', value: null, sortable: false },
      { text: 'Product', value: null, sortable: false },
      { text: 'Category', value: null, sortable: false },
      { text: 'SKU', value: null, sortable: false },
      { text: 'Seller Price', value: null, sortable: false },
      { text: 'My Price', value: null, sortable: false },
      { text: 'Suggested Price', value: null, sortable: false }
    ],
    items: [],
    filteredItems: [],
    loading: false,
    noData: false
  },
  filters: {
    categories: {
      isLoading: false,
      items: [],
      checked: [],
      model: null,
      search: null
    },
    brands: {
      isLoading: false,
      items: [],
      checked: [],
      model: null,
      search: null
    }
  }
}

const getters = {

}

const actions = {
  getProfitOpportunities ({ commit }, filter) {
    commit('SET_profitOpportunitiesLoading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'profitOpportunities',
        payload: {
          sellers: filter.sellers,
          categories: filter.categories,
          brands: filter.brands
        }
      })
        .then(response => {
          console.log('Profit Opportunities Loading', response.data.payload)
          commit('SET_title', response.data.payload.title)
          if (response.data.payload.opportunities.length > 0) {
            commit('SET_profitOpportunities', response.data.payload)
            commit('SET_profitOpportunitiesLoading', false)
            commit('SET_noData', false)
            resolve(1)
          } else {
            commit('SET_profitOpportunitiesLoading', false)
            commit('SET_noData', true)
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_profitOpportunities (state, data) {
    state.table.items = data.opportunities
    state.filters.categories.items = data.categories
    state.filters.brands.items = data.brands
  },
  ADD_filters (state, data) {
    let typeParent = null
    if (data.type === 'manufacturer_id') {
      typeParent = 'brands'
    } else if (data.type === 'category_id') {
      typeParent = 'categories'
    } else if (data.type === 'all') {
      // Reseting
      for (let i in state.filters) {
        state.filters[i].checked = []
      }
    }
    if (data.type !== 'all') {
      state.filters[typeParent].checked = data.item
      let arr = []
      for (let index in state.table.items) {
        if ((!state.filters.categories.checked.length || state.filters.categories.checked.indexOf(state.table.items[index].category_id) > -1) &&
          (!state.filters.brands.checked.length || state.filters.brands.checked.indexOf(state.table.items[index].brand_id) > -1)) {
          arr.unshift(state.table.items[index])
        }
      }
      state.table.filteredItems = arr
    }
  },
  SET_profitOpportunitiesLoading (state, bool) {
    state.table.loading = bool
  },
  SET_noData (state, bool) {
    state.table.noData = bool
    if (bool) {
      state.table.items = []
      state.table.filteredItems = []
    }
  },
  SET_title (state, data) {
    state.table.title = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics/profitOpportunities.js